export default __webpack_public_path__ + "static/media/logosvg.8d095da2.svg";